const FirstNotification = `Olá _*{{CONTACT.NAME}}*_,

Espero que você e seu bebê estejam bem. Sou _*{{USER.NAME}}*_, e no dia _*{{CONTACT.REFERENCE_DATE}}*_ lembra que batemos um papo no _*{{CONTACT.EXTENSION_ATTRIBUTES.HOSPITAL_NAME}}*_ sobre o projeto PEARLS da UNIFESP?

Gostaria de pedir um favorzinho! 🤭

Temos mais uma etapa da pesquisa e adoraríamos ter sua opinião novamente. É rapidinho, prometo! 🙏

Para participar, acesse: {{LINK.FORMS}}

Pedimos apenas, se possível que responda até _{{CALENDAR.END_AT}}_. Sua experiência pode fazer uma grande diferença para outras mães.

Agradeço desde já e fico à disposição para qualquer esclarecimento.

Até mais,

_*{{USER.NAME}}*_ e _*Equipe Projeto PEARLS Brazil*_ _UNIFESP_`;

export { FirstNotification };
